export default "__VITE_ASSET__3fb953e2__"